import React from 'react'
import { Modal } from 'react-bootstrap'
import { Errors } from '../../../../Component/Error'
import useMuiCompontent from '../../../../Hooks/useMuiCompontent'
import { SearchAbleSelectBox, SelectBox } from '../../../../Component/Inputs'
import { useEffect, useState } from 'react'
import useReduxData from '../../../../Hooks/useReduxData'
import { FaArrowLeft } from 'react-icons/fa'
import { toast } from 'react-toastify'
import { useFormik } from 'formik'
import { useNavigate, useParams } from 'react-router-dom'
import Loading from '../../../../Component/Loading'
import { RoleTitle, MedicineDosesUnitOptions } from '../../../../Context/constants'
import { inventoryValidation } from "../../../../Context/Validation";
import AddIcon from '@mui/icons-material/Add';
import { Fab, Tooltip } from '@mui/material';
import { UPDATE_INVENTORY, LIST_VENDOR, GET_INVENTORY_DETAILS, INSERT_CATEGORY, LIST_CATEGORY } from '../../../Repository/SettingRepo'

const EditInventoryDetails = () => {

    const { CustomButton } = useMuiCompontent()
    const [inventoryDetails, setInventoryDetails] = useState({})
    const navigate = useNavigate()
    const { id } = useParams()
    const { reduxData: userdata } = useReduxData("userDataRDX")
    const [listvendorData, setListVendorData] = useState([])
    const [listCategoryData, setListCategoryData] = useState([])
    const [loader, setLoader] = useState(false)
    const [openModal, setOpenModal] = useState({
        add: false,
        archive: false,
        tests: false,
        view: false,
        addCategory: false,
        data: null,
        previoursData: null
    })

    const getInventoryDetails = async () => {
        let payload = {
            inventoryId: id,
            providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK || userdata.roleTitle === RoleTitle.STAFF)
                ? userdata?.providerId
                : userdata?.userId,
        }
        setLoader(true)
        try {
            let response = await GET_INVENTORY_DETAILS(payload)
            setInventoryDetails(response?.data)
        } catch (error) {
            toast.error(error.message)
            setInventoryDetails({})
        } finally {
            setLoader(false)
        }
    }

    async function getFullVendorList(vendorId) {
        setLoader(true)
        const payload = {
            activeStatus: true,
            providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
            frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
        };
        try {
            let response = await LIST_VENDOR(payload)
            setListVendorData(response?.data);
            if (vendorId) {
                const vendorDetails = response.data.filter((cur) => cur?.id === vendorId)
                handleAddInventory.setFieldValue("vendor", vendorDetails)
            }
            setLoader(false)
        } catch (error) {
            if (error.message !== "No details found") toast.error(error.message)
            setListVendorData([])
            setLoader(false)
        }
    }

    async function getProductCategoryList(categoryId) {
        setLoader(true)
        const payload = {
            activeStatus: true,
            providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
            frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
        };
        try {
            let response = await LIST_CATEGORY(payload)
            setListCategoryData(response?.data);
            if (categoryId) {
                const categoryDetails = response.data.filter((cur) => cur?.id === categoryId)
                handleAddInventory.setFieldValue("category", categoryDetails)
            }
            setLoader(false)
        } catch (error) {
            if (error.message !== "No details found") toast.error(error.message)
            setListCategoryData([])
            setLoader(false)
        }
    }

    const addProductCategory = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: "",
        },
        onSubmit: async (values) => {
            console.log("Submitting payload", values);
            setLoader(true)
            let payload = {
                ...values,
                providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK || userdata.roleTitle === RoleTitle.STAFF) ? userdata?.providerId : userdata?.userId,
                frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
            }
            try {
                let response = await INSERT_CATEGORY(payload)
                toast.success(response.message)
                await getProductCategoryList()
                addProductCategory.resetForm()
                handleClosedModal("addCategory", true)
                setLoader(false)
            } catch (error) {
                toast.error(error.message)
                setLoader(false)
            }
        }
    })


    const handleOpenModal = (type, data = null) => {
        setOpenModal((prev) => ({
            ...prev,
            data: data,
            previoursData: data,
            [type]: true,
        }));
    };
    const handleClosedModal = (type, isNull) => {
        setOpenModal((pre) => ({
            ...pre,
            data: null,
            previoursData: isNull ? null : pre?.previoursData,
            [type]: false
        }))
    }

    // inventory
    const handleAddInventory = useFormik({
        enableReinitialize: true,
        initialValues: {
            batchNumber: inventoryDetails?.batchNumber || "",
            quantity: inventoryDetails?.quantity || 0,
            manufactureDate: inventoryDetails?.manufactureDate || "",
            expiryDate: inventoryDetails?.expiryDate || "",
            productName: inventoryDetails?.productName || "",
            marketPrice: inventoryDetails?.marketPrice || "",
            purchasePrice: inventoryDetails?.purchasePrice || "",
            sellingPrice: inventoryDetails?.sellingPrice || "",
            category: [],
            type: inventoryDetails?.type || "",
            unit: inventoryDetails?.unit || "",
            composition: inventoryDetails?.composition || "",
            dosageForm: inventoryDetails?.dosageForm || "",
            strength: inventoryDetails?.strength || "",
            brandName: inventoryDetails?.brandName || "",
            reOrderLevel: inventoryDetails?.reOrderLevel ? "YES" : "NO",
            reOrderQty: inventoryDetails?.reOrderQty,
            vendor: [],
        },
        validationSchema: inventoryValidation,
        onSubmit: async (values) => {
            // const { clone, ...restValue } = values
            console.log("Submitting payload", values);
            setLoader(true)
            let payload = {
                ...values,
                inventoryId: id,
                providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK || userdata.roleTitle === RoleTitle.STAFF) ? userdata?.providerId : userdata?.userId,
                frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
                roleTitle: userdata.roleTitle,
                // ...restValue,
                vendor: values.vendor?.[0]?.id,
                category: values.category?.[0]?.id,
                // reOrderLevel: values.reOrderLevel === "YES" ? true : false,
            }
            try {
                let response = await UPDATE_INVENTORY(payload)
                toast.success(response.message)
                getInventoryDetails()
                navigate("/setting/inventory", { state: { tab: 2 } })
                setLoader(false)
            } catch (error) {
                toast.error(error.message)
                setLoader(false)
            }
        }
    })

    console.log(handleAddInventory?.values?.batchNumber, "handleAddInventory?.values?.batchNumber")

    const handalSearchAbleSelectBox = (event, newValue, name) => {
        if (name === "vendor") {
            handleAddInventory.setFieldValue("vendor", newValue)
        } else if (name === "category") {
            handleAddInventory.setFieldValue("category", newValue)
        } else {
            handleAddInventory.setFieldValue(name, newValue)
        }
    }

    useEffect(() => {
        getInventoryDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getFullVendorList(null);
        getProductCategoryList(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (inventoryDetails?.vendorId) {
            const vendorDetails = listvendorData.filter(
                (cur) => cur?.id === inventoryDetails?.vendorId
            );
            handleAddInventory.setFieldValue("vendor", vendorDetails);
        }
        if (inventoryDetails?.categoryId) {
            const categoryDetails = listCategoryData.filter(
                (cur) => cur?.id === inventoryDetails?.categoryId
            );
            handleAddInventory.setFieldValue("category", categoryDetails);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inventoryDetails, listvendorData]);



    return (
        <>
            {loader && <Loading />}
            <div className="common-component-box">
                <header className="body_header">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
                        <div className="d-flex align-items-center mb-2 mb-md-0">
                            <FaArrowLeft
                                className="me-2 cursor"
                                onClick={() => navigate("/setting/inventory", { state: { tab: 2 } })}
                                role="button"
                                aria-label="Go Back"
                                title="Go Back"
                                style={{ fontSize: "1.2rem" }}
                            />
                            <h2 className="page_name mb-0">Inventory Details</h2>
                        </div>
                    </div>
                </header>

                <div className="row common-white-bg-box mx-0 shadow d-flex align-content-start  position-relative px-2">
                    {/* <div className="row"> */}
                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label">Batch Number<span className='Star_Mark'>*</span></label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input
                                            type="text"
                                            name="batchNumber"
                                            className="form-control"
                                            value={handleAddInventory?.values.batchNumber || ""}
                                            aria-describedby="emailHelp"
                                            onChange={(e) => handleAddInventory.setFieldValue("batchNumber", e.target.value)}
                                            onInput={(e) => { if (e.target.value.length > 100) e.target.value = e.target.value.slice(0, 100); }}
                                            maxLength={100}
                                        />
                                        <Errors formikfun={handleAddInventory} name={"batchNumber"} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label">Product Name<span className='Star_Mark'>*</span></label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input
                                            type="text"
                                            name="productName"
                                            className="form-control"
                                            value={handleAddInventory?.values.productName || ""}
                                            aria-describedby="emailHelp"
                                            onChange={(e) => handleAddInventory.setFieldValue("productName", e.target.value)}
                                            onInput={(e) => { if (e.target.value.length > 100) e.target.value = e.target.value.slice(0, 100); }}
                                            maxLength={100}
                                        />
                                        <Errors formikfun={handleAddInventory} name={"productName"} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Item Name */}
                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0">Category<span className='Star_Mark'>*</span></label>
                                    </div>
                                    <div className="col-lg-7 d-flex">
                                        <div className="col-lg-11 w-100">
                                            <SearchAbleSelectBox
                                                multiple={false}
                                                option={listCategoryData}
                                                getOptionLabel="name"
                                                isOptionEqualToValue="id"
                                                value={handleAddInventory?.values?.category}
                                                name="category"
                                                handalSearchAbleSelectBox={handalSearchAbleSelectBox}
                                            />
                                            <Errors formikfun={handleAddInventory} name="category" />
                                        </div>
                                        <div className="col-lg-1 text-center px-4">

                                            <Tooltip title=" Add Category" placement="right" style={{ cursor: "pointer" }}>
                                                <Fab color="primary" aria-label="add" size="small" className='mt-1' style={{ background: "#38C4B9", width: "27px", height: "27px", minHeight: "0" }}
                                                    onClick={() => {
                                                        handleOpenModal("addCategory", openModal?.previoursData);
                                                        handleClosedModal("add");
                                                    }}
                                                >
                                                    <AddIcon />
                                                </Fab>
                                            </Tooltip>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label">Brand Name<span className='Star_Mark'>*</span></label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input
                                            type="text"
                                            name="brandName"
                                            className="form-control"
                                            value={handleAddInventory?.values.brandName || ""}
                                            aria-describedby="emailHelp"
                                            onChange={(e) => handleAddInventory.setFieldValue("brandName", e.target.value)}
                                            onInput={(e) => { if (e.target.value.length > 100) e.target.value = e.target.value.slice(0, 100); }}
                                            maxLength={100}
                                        />
                                        <Errors formikfun={handleAddInventory} name={"brandName"} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label">Type</label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input
                                            type="text"
                                            name="type"
                                            className="form-control"
                                            value={handleAddInventory?.values.type || ""}
                                            aria-describedby="emailHelp"
                                            onChange={(e) => handleAddInventory.setFieldValue("type", e.target.value)}
                                            onInput={(e) => { if (e.target.value.length > 100) e.target.value = e.target.value.slice(0, 100); }}
                                            maxLength={100}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label">Strength</label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input
                                            type="text"
                                            name="strength"
                                            className="form-control"
                                            value={handleAddInventory?.values.strength || ""}
                                            aria-describedby="emailHelp"
                                            onChange={(e) => handleAddInventory.setFieldValue("strength", e.target.value)}
                                            onInput={(e) => { if (e.target.value.length > 100) e.target.value = e.target.value.slice(0, 100); }}
                                            maxLength={100}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label">unit</label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input
                                            type="text"
                                            name="unit"
                                            className="form-control"
                                            value={handleAddInventory?.values.unit || ""}
                                            aria-describedby="emailHelp"
                                            onChange={(e) => handleAddInventory.setFieldValue("unit", e.target.value)}
                                            onInput={(e) => { if (e.target.value.length > 100) e.target.value = e.target.value.slice(0, 100); }}
                                            maxLength={100}
                                        />
                                        {/* <SelectBox
                                            placeholder="Select"
                                            value={handleAddInventory?.values.unit || ""}
                                            name="archive"
                                            keys="value"
                                            label="label"
                                            menuValeu="value"
                                            handleChange={(e) => { handleAddInventory.setFieldValue("unit", e.target.value); }}
                                            option={MedicineDosesUnitOptions}
                                        /> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label">Composition</label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input
                                            type="text"
                                            name="composition"
                                            className="form-control"
                                            value={handleAddInventory?.values.composition || ""}
                                            aria-describedby="emailHelp"
                                            onChange={(e) => handleAddInventory.setFieldValue("composition", e.target.value)}
                                            onInput={(e) => { if (e.target.value.length > 100) e.target.value = e.target.value.slice(0, 100); }}
                                            maxLength={100}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label">Dosage Form</label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input
                                            type="text"
                                            name="dosageForm"
                                            className="form-control"
                                            value={handleAddInventory?.values.dosageForm || ""}
                                            aria-describedby="emailHelp"
                                            onChange={(e) => handleAddInventory.setFieldValue("dosageForm", e.target.value)}
                                            onInput={(e) => { if (e.target.value.length > 100) e.target.value = e.target.value.slice(0, 100); }}
                                            maxLength={100}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label">Manufacture Date<span className="Star_Mark">*</span></label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input
                                            type="date"
                                            className="form-control position-relative"
                                            value={handleAddInventory?.values?.manufactureDate || ""}
                                            onChange={(e) => handleAddInventory.setFieldValue("manufactureDate", e.target.value)}
                                        />
                                        <Errors formikfun={handleAddInventory} name="manufactureDate" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label">Expiration Date<span className="Star_Mark">*</span></label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input
                                            type="date"
                                            className="form-control position-relative"
                                            value={handleAddInventory?.values?.expiryDate || ""}
                                            onChange={(e) => handleAddInventory.setFieldValue("expiryDate", e.target.value)}
                                        />
                                        <Errors formikfun={handleAddInventory} name="expiryDate" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label">MRP<span className='Star_Mark'>*</span></label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input
                                            type="number"
                                            name="marketPrice"
                                            className="form-control"
                                            value={handleAddInventory?.values.marketPrice || ""}
                                            aria-describedby="emailHelp"
                                            onChange={(e) => handleAddInventory.setFieldValue("marketPrice", e.target.value)}
                                            onInput={(e) => { if (e.target.value.length > 4) e.target.value = e.target.value.slice(0, 4); }}
                                            maxLength={4}
                                        />
                                        <Errors formikfun={handleAddInventory} name={"marketPrice"} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label">Purchase Price<span className='Star_Mark'>*</span></label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input
                                            type="number"
                                            name="purchasePrice"
                                            className="form-control"
                                            value={handleAddInventory?.values.purchasePrice || ""}
                                            aria-describedby="emailHelp"
                                            onChange={(e) => handleAddInventory.setFieldValue("purchasePrice", e.target.value)}
                                            onInput={(e) => { if (e.target.value.length > 4) e.target.value = e.target.value.slice(0, 4); }}
                                            maxLength={4}
                                        />
                                        <Errors formikfun={handleAddInventory} name={"purchasePrice"} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label">Selling Price<span className='Star_Mark'>*</span></label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input
                                            type="number"
                                            name="sellingPrice"
                                            className="form-control"
                                            value={handleAddInventory?.values.sellingPrice || ""}
                                            aria-describedby="emailHelp"
                                            onChange={(e) => handleAddInventory.setFieldValue("sellingPrice", e.target.value)}
                                            onInput={(e) => { if (e.target.value.length > 4) e.target.value = e.target.value.slice(0, 4); }}
                                            maxLength={4}
                                        />
                                        <Errors formikfun={handleAddInventory} name={"sellingPrice"} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label">Quantity<span className="Star_Mark">*</span></label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input
                                            type="number"
                                            name="quantity"
                                            className="form-control"
                                            value={handleAddInventory?.values.quantity != null ? handleAddInventory.values.quantity : ""}
                                            onChange={(e) => handleAddInventory.setFieldValue("quantity", e.target.value)}
                                            onInput={(e) => { if (e.target.value.length > 4) e.target.value = e.target.value.slice(0, 4); }}
                                        />
                                        <Errors formikfun={handleAddInventory} name="quantity" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label">Vendor<span className="Star_Mark">*</span></label>
                                    </div>
                                    <div className="col-lg-7">
                                        <SearchAbleSelectBox
                                            placeholder="Select Vendor"
                                            multiple={false}
                                            option={listvendorData}
                                            getOptionLabel="name"
                                            isOptionEqualToValue="id"
                                            value={handleAddInventory?.values?.vendor}
                                            name="vendor"
                                            handalSearchAbleSelectBox={handalSearchAbleSelectBox}
                                        />
                                        <Errors formikfun={handleAddInventory} name="vendor" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label">Re-Order Level</label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input
                                            type="number"
                                            name="quantity"
                                            className="form-control"
                                            value={handleAddInventory?.values.reOrderQty || ""}
                                            onChange={(e) => handleAddInventory.setFieldValue("reOrderQty", e.target.value)}
                                            onInput={(e) => { if (e.target.value.length > 4) e.target.value = e.target.value.slice(0, 4); }}
                                        />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="col-sm-12 py-3" style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row align-items-center flex-nowrap">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0">
                                            Re-Order Level<span className="Star_Mark">*</span>
                                        </label>
                                    </div>

                                    <div className="col-lg-7 d-flex align-items-center">
                                        <div className="form-check me-3">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="reOrderLevel"
                                                id="reOrderYes"
                                                value="YES"
                                                checked={handleAddInventory.values.reOrderLevel === "YES"}
                                                onChange={(e) =>
                                                    handleAddInventory.setFieldValue("reOrderLevel", e.target.value)
                                                }
                                            />
                                            <label className="form-check-label" htmlFor="reOrderYes">
                                                Yes
                                            </label>
                                        </div>

                                        <div className="form-check me-3">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="reOrderLevel"
                                                id="reOrderNo"
                                                value="NO"
                                                checked={handleAddInventory.values.reOrderLevel === "NO"}
                                                onChange={(e) => {
                                                    handleAddInventory.setFieldValue("reOrderLevel", e.target.value);
                                                    handleAddInventory.setFieldValue("reOrderQty", "");
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="reOrderNo">
                                                No
                                            </label>
                                        </div>

                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Enter quantity"
                                            value={handleAddInventory.values.reOrderQty || ""}
                                            onChange={(e) =>
                                                handleAddInventory.setFieldValue("reOrderQty", e.target.value)
                                            }
                                            style={{ width: "120px" }}
                                            disabled={handleAddInventory.values.reOrderLevel !== "YES"}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    <div className="col-sm-12 d-grid justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-end justify-content-xl-end justify-content-xxl-end py-3">
                        <CustomButton variant="contained" onClick={handleAddInventory.handleSubmit} >Update</CustomButton>
                    </div>
                </div>
                {/* </div> */}
            </div >
            <Modal show={openModal.addCategory} onHide={() => handleClosedModal("addCategory")} centered>
                <Modal.Body>
                    <div className="text-center">
                        <h4 className="modal-title mb-3">Add Category</h4>
                    </div>
                    <div className="modal-body  cus-i">
                        <div className="mb-3">
                            <label htmlFor="exampleInputEmail1" className="form-label mb-0">Category<span className='Star_Mark'>*</span></label>
                            <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                value={addProductCategory?.values?.name}
                                onChange={(e) => addProductCategory?.setFieldValue("name", e.target.value)}
                            />
                            <Errors formikfun={addProductCategory} name={"name"} />
                        </div>
                    </div>
                    <div className="text-center mt-3">
                        <CustomButton variant="contained" onClick={addProductCategory.handleSubmit} >Save</CustomButton>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default EditInventoryDetails